import styled, { keyframes } from "styled-components";
import logo from "../../images/mechta_logo.png";

interface Props {
  fullscreen?: boolean;
  compact?: boolean;
  label?: string;
}

export const Loader = ({
  fullscreen = false,
  compact = false,
  label = "Загрузка...",
}: Props) => {
  return (
    <Wrapper $fullscreen={fullscreen} $compact={compact}>
      <LoaderBox>
        <RingWrap>
          <Ring viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <circle
              cx="50"
              cy="50"
              r="44"
              fill="none"
              stroke="var(--color-primary-soft)"
              strokeWidth="6"
            />
            <circle
              cx="50"
              cy="50"
              r="44"
              fill="none"
              stroke="var(--color-primary)"
              strokeWidth="6"
              strokeLinecap="round"
              strokeDasharray="80 220"
            />
          </Ring>
          <LogoImg src={logo} alt="Мечта" />
        </RingWrap>
        <Label>{label}</Label>
        <Dots>
          <Dot />
          <Dot />
          <Dot />
        </Dots>
      </LoaderBox>
    </Wrapper>
  );
};

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(0.92); opacity: 0.85; }
`;

const bounce = keyframes`
  0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
  40% { transform: translateY(-6px); opacity: 1; }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const Wrapper = styled.div<{ $fullscreen: boolean; $compact: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ $fullscreen, $compact }) =>
    $fullscreen
      ? `
    position: fixed;
    inset: 0;
    background: rgba(255, 255, 255, 0.92);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    z-index: 9999;
  `
      : $compact
      ? `
    min-height: 240px;
    padding: 24px 16px;
  `
      : `
    min-height: 60vh;
    padding: 40px 20px;
  `}
  animation: ${fadeIn} 220ms ease;
`;

const LoaderBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
`;

const RingWrap = styled.div`
  position: relative;
  width: 96px;
  height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Ring = styled.svg`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  animation: ${spin} 1.1s linear infinite;
`;

const LogoImg = styled.img`
  width: 56px;
  height: 56px;
  object-fit: contain;
  animation: ${pulse} 1.6s ease-in-out infinite;
`;

const Label = styled.p`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--color-primary);
  letter-spacing: 0.3px;
`;

const Dots = styled.div`
  display: flex;
  gap: 6px;
`;

const Dot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--color-primary);
  animation: ${bounce} 1.2s ease-in-out infinite;

  &:nth-child(2) {
    animation-delay: 0.15s;
  }

  &:nth-child(3) {
    animation-delay: 0.3s;
  }
`;
